module.exports = __webpack_public_path__ + "img/third_ch.16534e47.jpg";